export { LmScorm1_2Api } from './LmScorm1_2Api';



// WEBPACK FOOTER //
// ./src/logic/scorm/impl/legacy/index.ts